import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { BannerText } from '../BannerText';
export const BannerTextOnly = ({ text, centered, theme = 'light', }) => {
    const background = backgroundValue[theme];
    return (_jsx(Box, { display: "flex", flexWrap: "wrap", alignItems: "stretch", minHeight: "400px", backgroundColor: background, children: _jsx(BannerText, { root: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: centered ? 'center' : undefined,
                textAlign: centered ? 'center' : undefined,
                px: ['20px', null, '40px'],
                py: ['20px', null, '40px'],
                width: '100%',
                ...text?.root,
            }, eyebrow: {
                textStyle: ['Mobile/Eyebrow', null, 'Desktop/Eyebrow'],
                textColor: ['text', null, 'text'],
                ...text?.eyebrow,
            }, title: {
                textStyle: ['Mobile/L', null, 'Desktop/XL'],
                textColor: ['text', null, 'text'],
                ...text?.title,
            }, body: {
                textStyle: ['Mobile/Body-Default', null, 'Desktop/Body-L'],
                textColor: ['text', null, 'text'],
                ...text?.body,
            }, ctaButtonPrimary: {
                variant: 'outline',
                ...text?.ctaButtonPrimary,
            }, ctaButtonBox: {
                justifyContent: centered ? 'center' : undefined,
                ...text?.ctaButtonBox,
            } }) }));
};
const backgroundValue = {
    light: 'primary.light',
    dark: 'primary',
};
